/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import AccordionControl from 'app/components/common/AccordionControl.jsx';
import classnames from 'classnames';
import ConstantMixin from 'app/mixins/ConstantMixin.js';
import ErrorModule from 'app/mixins/ErrorModule.jsx';
import * as IconFactory from 'app/components/common/IconFactory.jsx';
import ListModule from 'app/mixins/ListModule.js';
import SocialListDetail from 'app/components/SocialLists/SocialListDetail.jsx';
import SocialListModule from 'app/mixins/SocialListModule.js';
import SocialAvatar from 'app/components/common/SocialAvatar.jsx';
import * as _ from 'underscore';

class SocialListItem extends React.Component {
	constructor(props) {
		super(props);

		this.itemRef = React.createRef();
		SocialListModule.reauthorizeSocialClick = SocialListModule.reauthorizeSocialClick.bind(this);

	}

	componentDidMount() {

		if (this.props.showDetail && this.props.social.id) {
			this.itemRef.current.scrollIntoView(false);
		}

	}


	render() {
		let Icon = IconFactory[ConstantMixin.getIconIndexByCode(this.props.social.psID)],
			inactive = parseInt(this.props.social.activeFlag, 10) ? false : true,
			sysActionFlag = parseInt(this.props.social.sysActionFlag, 10) ? true : false,
			accordionOpen = false,
			itemClass = classnames(
				'dlvr-list-item', {
					'detail': (this.props.showDetail) ? true : false,
					'inactive': inactive,
					'blur': (this.props.showDetail) ? true : false,
					'disconnected': sysActionFlag
				}
			),
			itemNameClass = classnames(
				'item-input-label', {
					'inactive': inactive
				}
			),
			status = null,
			postTs = (this.props.social.lastPost !== undefined && this.props.social.lastPost.postTs !== undefined) ? this.props.social.lastPost.postTs : '',
			statusClass = '',
			detailBlock = null,
			statusLabel = null,
			itemStatusClass = classnames(
				'item-status-label', {
					'inactive': inactive
				}
			),
			clientName = null;

		status = this.props.setStatus(this.props.social.activeFlag, postTs);

		statusClass = classnames(
			'item-row-cell status',
			status.className, {
				'inactive': (inactive && !sysActionFlag)
			}
		);

		if (this.props.showDetail) {
			//let messages = SocialStore.getMessages('social', this.props.social.id);
			let messages = [];
			accordionOpen = true;

			detailBlock = (
				<SocialListDetail
					  {...this.props}
					  social={this.props.social}
					  messages={messages}
					  errors={this.props.socialErrors} />
			);
		}

		if ((parseInt(this.props.social.sysActionFlag, 10) === 1 && parseInt(this.props.social.activeFlag, 10) === 0) && this.props.social.externalID !== undefined && this.props.social.clientPubID === 0) {
			statusLabel = (
				<div className="route-status-label">
					  <button className="btn-primary reverse-fixed social-list" onClick={SocialListModule.reauthorizeSocialClick} data-id={this.props.social.id} data-serviceid={this.props.social.psID}>
						  Reconnect
					  </button>
				  </div>
			);
		} else {
			statusLabel = (
				<div className="route-status-label">
					  {status.label}
				  </div>
			);
		}

		if (this.props.social.clientPubID !== 0 && this.props.appName === "dlvr") {
			let client = this.props.subaccounts.list.find((subaccount) => { return subaccount.id === this.props.social.clientPubID; });
			if (client && client.clientName !== undefined) {
				clientName = (
					<span>({client.clientName})</span>
				);
			}
		}

		return (
			<li className={itemClass} ref={this.itemRef}>
				<div className="list-item-row" onClick={this.props.detailHandler} data-id={this.props.social.id} role="switch" aria-label="show detail">
					<AccordionControl accordionOpen={accordionOpen} />
					<div className="item-row-cell input-label">
						<div className="item-icon-wrapper">
							<SocialAvatar
								social={this.props.social}
								compact={true}
								showCompactName={false}
								inactive={inactive}/>
						</div>
						<div className={itemNameClass} title={this.props.social.name} alt={this.props.social.name}>
							{this.props.social.name || ''} {clientName}
						</div>
					</div>
					<div className={statusClass}>
						<span className={itemStatusClass}>
							{status.label}
						</span>
						<span className="item-status-icon">
							{status.icon}
						</span>
					</div>
				</div>
				{detailBlock}
			</li>
		);
	}
}

SocialListItem.displayName = "SocialListItem";

SocialListItem.propTypes = {
  social: PropTypes.object,
  detailHandler: PropTypes.func,
};

SocialListItem.defaultProps = {
	social: {},
	detailHandler: () => {},
	showDetail: false,
};

export default ListModule(SocialListItem);
